export default __webpack_public_path__ + "static/media/Screenshot_1619919006.c631e58d.png";